module.exports = __webpack_public_path__ + "static/media/stripe_logo.4d02c376.svg";